import React from "react";
import { populatePokemons, setCount } from "../actions/pokemon";
import { PokemonListContext } from "../context/pokemonContext";
import { filterPokemons } from "../selectors/pokemon";
import Card from "./Card";

const DashBoard = () => {

    const { pokemons, dispatchPokemons, filters, dispatchFilters } = React.useContext(PokemonListContext);

    React.useEffect(() => {
        fetch(`https://pokeapi.co/api/v2/pokemon?limit=1120`)
            .then((response) => response.json())
            .then((data) => {
                dispatchPokemons(populatePokemons(data.results));
            })
            .catch((error) => {});
            
    }, []);

    const visiblePokemons = filterPokemons(pokemons,filters);

    console.log(visiblePokemons);

    window.addEventListener('scroll', () => {

        if (filters.count<1120 && (window.scrollY + window.innerHeight + 100) >= document.body.offsetHeight) {
            dispatchFilters(setCount(filters.count+48));
        }
    });

    return (
        <div className="d-flex flex-wrap justify-content-center">

            {
                visiblePokemons.map(({ name }, index) => {
                    return <Card key={index} name={name} />
                })
            }
        </div>
    );
};

export default DashBoard;